class SecondhandImage extends HTMLElement {
  connectedCallback() {
    const image = this.querySelector('img');

    if (!(image instanceof HTMLImageElement)) {
      this.classList.add('is-loaded');
      return;
    }

    const reveal = async () => {
      if (!image.naturalWidth) {
        this.classList.add('is-error');
        return;
      }

      try {
        await image.decode();
      } catch {
        // A load event still confirms that the image can be displayed.
      }

      this.classList.add('is-loaded');
    };

    if (image.complete) {
      void reveal();
      return;
    }

    image.addEventListener('load', reveal, { once: true });
    image.addEventListener('error', () => this.classList.add('is-error'), { once: true });
  }
}

if (!customElements.get('secondhand-image')) {
  customElements.define('secondhand-image', SecondhandImage);
}
